import { render, staticRenderFns } from "./SwitchDebrisTypeTable.vue?vue&type=template&id=36bea3c5&"
import script from "./SwitchDebrisTypeTable.vue?vue&type=script&lang=js&"
export * from "./SwitchDebrisTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports